import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from "@angular/core";

import { IconRegistry } from "./icons/icon-registry";

export function provideDesignSystem(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => inject(IconRegistry).register())
  ]);
}
